import React, { memo, useState } from "react";
import { withNamespaces } from "react-i18next";
import { useQuery } from "@tanstack/react-query";
import { Col, Row } from "reactstrap";
import {
    Dropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem
} from "react-bootstrap";
import { toast } from "react-toastify";
import DataProtectionSoftwareService from "src/modules/data-protection/apis/DataProtectionSoftwareService";
import FilteringComponent from "./components/filtering-component";
import RiskOverviewCards from "./components/risk-overview-cards";
import AiAssetsOverviewTable from "./components/ai-assets-overview-table";
import AiRiskDistribution from "./components/ai-risk-distribution";
import AiModelsByRiskLevels from "./components/ai-models-by-risk-levels";
import RiskLevels from "./components/risk-levels";
import MitigationTasks from "./components/mitigation-tasks";
import TaskPriorityOverview from "./components/task-priority-overview";
import RecentActivity from "./components/recent-activity";
import RiskMatrix from "./components/risk-matrix";
import MitigatedAndAcceptedRisksCreated from "./components/mitigated-and-accepted-risks-created";

const AiGovernanceDashboard = memo(({ t }) => {
    const [moreActionsDropDownOpen, setMoreActionsDropDownOpen] = useState(false);
    const handleFetchAiDashboardQuery = useQuery({
        queryKey: ["data-protection-ai-risk-assessment-dashboard"],
        queryFn: async () => {
            const service = DataProtectionSoftwareService.getInstance();
            return await service.aiRiskAssessmentDashboard();
        },
        cacheTime: 0,
        refetchOnWindowFocus: false,
        onError: (error) => {
            if (process.env.NODE_ENV === "development") console.error(error);

            toast(t("An error occurred while fetching dashboard data."), {
                type: "error",
            });
        },
    });

    return (
            <>
            <Row>
                <Col sm="12" md="12" lg="4" className="mb-3">
                    <h5 className="mb-0">{t("AI Risk Overview")}</h5>
                </Col>

                <Col sm="12" md="12" lg="8" className="mb-3 d-flex justify-content-end">
                    <div className="d-flex">
                        <FilteringComponent
                            onChange={() => {}}
                            fetchOwnersQuery={{
                                isFetching: false,
                                data: [],
                            }}
                            tab="ai-governance-dashboard"
                        />

                        {/* <Dropdown
                            isOpen={moreActionsDropDownOpen}
                            onToggle={(isOpen) => setMoreActionsDropDownOpen(isOpen)}
                        >
                            <DropdownToggle
                                caret
                                variant="outline-secondary"
                                outline
                            >
                                {t("Actions")}
                            </DropdownToggle>
                            <DropdownMenu className="dropdown-menu-end">
                                <DropdownItem>
                                    {t("No actions available")}
                                </DropdownItem>
                            </DropdownMenu>
                        </Dropdown> */}
                    </div>
                </Col>
            </Row>

            <RiskOverviewCards
                data={handleFetchAiDashboardQuery.data?.aiRiskOverview}
                isFetching={handleFetchAiDashboardQuery.isFetching}
            />
            <AiAssetsOverviewTable
                data={handleFetchAiDashboardQuery.data?.aiAssetsOverview}
                isFetching={handleFetchAiDashboardQuery.isFetching}
            />

            <Row>
                <Col lg="4">
                    <AiRiskDistribution
                        distribution={handleFetchAiDashboardQuery.data?.aiRiskDistribution}
                        totalAiAssets={
                            handleFetchAiDashboardQuery.data?.aiRiskOverview?.totalAiAssets
                                ?.amount ??
                            handleFetchAiDashboardQuery.data?.aiRiskOverview?.totalAiAssets
                        }
                        isFetching={handleFetchAiDashboardQuery.isFetching}
                    />
                </Col>

                <Col lg="5">
                    <AiModelsByRiskLevels
                        modelsByRisk={handleFetchAiDashboardQuery.data?.aiModelsByRiskLevels}
                        isFetching={handleFetchAiDashboardQuery.isFetching}
                    />
                </Col>

                <Col lg="3">
                    <RiskLevels
                        riskLevels={handleFetchAiDashboardQuery.data?.riskLevels}
                        isFetching={handleFetchAiDashboardQuery.isFetching}
                    />
                </Col>
            </Row>

            <Row>
                <Col lg="4">
                    <MitigationTasks
                        data={handleFetchAiDashboardQuery.data?.mitigationTasks}
                        isFetching={handleFetchAiDashboardQuery.isFetching}
                    />
                </Col>

                <Col lg="5">
                    <TaskPriorityOverview
                        data={handleFetchAiDashboardQuery.data?.taskPriorityOverview}
                        isFetching={handleFetchAiDashboardQuery.isFetching}
                    />
                </Col>

                <Col lg="3">
                    <RecentActivity
                        data={handleFetchAiDashboardQuery.data?.recentActivity}
                        isFetching={handleFetchAiDashboardQuery.isFetching}
                    />
                </Col>
            </Row>

            <Row>
                <Col lg="8" className="d-flex align-items-stretch">
                    <RiskMatrix
                        data={handleFetchAiDashboardQuery.data?.riskMatrix}
                        isFetching={handleFetchAiDashboardQuery.isFetching}
                    />
                </Col>

                <Col lg="4" className="d-flex align-items-stretch">
                    <MitigatedAndAcceptedRisksCreated
                        createdRisksAndTasks={handleFetchAiDashboardQuery.data?.createdRisksAndTasks}
                        mitigatedAndAcceptedRisks={handleFetchAiDashboardQuery.data?.mitigatedAndAcceptedRisks}
                        isFetching={handleFetchAiDashboardQuery.isFetching}
                    />
                </Col>
            </Row>
        </>
    );
});

export default withNamespaces()(AiGovernanceDashboard);
